enum Emmision {
    FUEL = 1,
    ELECTRICITY = 1.35,
    TRANSPORTATION = 1.75,
    WATER = 0.5,
}

export default Emmision;